module.exports = __webpack_public_path__ + "img/1920_akitorg_main-min.bc9ca577.jpg";